import { render, staticRenderFns } from "./Transaction.vue?vue&type=template&id=607a1f3a&scoped=true"
import script from "./Transaction.vue?vue&type=script&lang=ts"
export * from "./Transaction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607a1f3a",
  null
  
)

export default component.exports